import React from 'react'
import PageHeader from '../components/shared/pageHeader/PageHeader'
import LeadsViewHeader from '../components/leadsViewCreate/LeadsViewHeader'
import LeadssTable from '../components/leads/AuthorizationTable'
import Footer from '../components/shared/Footer'

const ModuleTable = () => {
    return (
        <>
            <PageHeader>
                <LeadsViewHeader />
            </PageHeader>
            <div className='main-content'>
                <div className='row'>
                    <LeadssTable />
                </div>
            </div>
            
        </>
    )
}

export default ModuleTable